import { Box, Stack } from '@mui/material';
import PerfectScrollbar from 'react-perfect-scrollbar';
import Stepper from '../../components/stepper/stepper';
import StepperProvider from '../../components/stepper/stepper.provider';
import HelperProvider from '../../contexts/helper-context/helper-provider';
import Steps from './components/Steps';
import { packageFormDefaultValues } from './constants';

const steps = [
    {
        label: 'Product Details',
        value: 'product-details',
    },
    {
        label: 'Unit Products',
        value: 'unit-products',
    },
    {
        label: 'Pricing and Financial',
        value: 'pricing',
    },
    {
        label: 'Assets',
        value: 'assets',
    },
    {
        label: 'Preview',
        value: 'preview',
    },
];

function AddPackage() {
    return (
        <StepperProvider steps={steps} defaultState={packageFormDefaultValues}>
            <HelperProvider>
                <Stack
                    direction="row"
                    sx={{ height: 1 }}
                    spacing={1}
                    p={{ xs: 0, md: 2 }}
                >
                    <Box
                        sx={{
                            flexGrow: 1,
                            bgcolor: '#FFFFFF',
                            p: { xs: 1, md: 3 },
                            pr: { xs: 0, md: 2 },
                            pl: { xs: 2, md: 3 },
                            overflow: 'auto',
                            position: 'relative',
                        }}
                    >
                        <Steps />
                    </Box>
                    <Box
                        sx={{
                            display: { xs: 'none', sm: 'block' },
                            p: 0.5,
                            flexShrink: 0,
                            width: 260,
                            bgcolor: '#FFFFFF',
                            overflow: 'auto',
                        }}
                    >
                        <PerfectScrollbar>
                            <Stepper />
                        </PerfectScrollbar>
                    </Box>
                </Stack>
            </HelperProvider>
        </StepperProvider>
    );
}

export default AddPackage;
